import React from 'react';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { SectionShell } from '../SectionShell';
import { CTAButton } from '../CTAButton';
const steps = ['Review the 6 volumes.', 'Explore the cards.', 'Open the clinical cases.', 'Use the visual maps.', 'Review the checklists.'];
export function Guarantee() {
  return <SectionShell tone="darker" data-id="element-175" data-mp="29f7zfqsa69kw">
      <div className="rounded-2xl border border-emerald-400/30 bg-navy-900 p-6 text-center sm:p-8" data-id="element-176" data-mp="2ed031i2afk4x">
        <ShieldCheckIcon className="mx-auto h-14 w-14 text-emerald-400" aria-hidden="true" data-id="element-177" data-mp="2jc4e6e8rvrxw" />
        <p className="mt-3 font-display text-sm uppercase tracking-[0.2em] text-emerald-400" data-id="element-178" data-mp="2oaxq428evavy">
          7-Day Guarantee
        </p>
        <h2 className="mt-2 font-display text-2xl uppercase leading-tight text-white sm:text-4xl" data-id="element-179" data-mp="2sc98pnsvavun">
          Review it. Explore it. Decide.
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-sky-100/75" data-id="element-180" data-mp="xyi452peb262">
          You have 7 days to explore the TRT Decision Deck™.
        </p>

        <ul className="mx-auto mt-5 grid max-w-md gap-2 text-left" data-id="element-181" data-mp="3smzrnbzqnw2t">
          {steps.map(step => <li key={step} className="flex items-center gap-2 text-sm text-sky-100/85" data-id="element-182" data-mp="3nt5d0myzq7al">
              <CheckIcon className="h-4 w-4 shrink-0 text-emerald-400" aria-hidden="true" data-id="element-183" data-mp="3iwewjyj9x9on" />
              {step}
            </li>)}
        </ul>

        <p className="mt-5 text-sm leading-relaxed text-sky-100/65" data-id="element-184" data-mp="femxk06pzpgy">
          If you decide the system isn’t the right resource for your needs, you can request a refund
          within the applicable 7-day guarantee period according to the refund policy.
        </p>

        <div className="mt-7" data-id="element-185" data-mp="5ito4poasc3e">
          <CTAButton label="Try the TRT Decision Deck™ for 7 days" subline="$27 one-time · Risk-free for 7 days" data-id="element-186" data-mp="hw4s9rjxc0b" />
        </div>
      </div>
    </SectionShell>;
}